import {
  Box,
  Button,
  Flex,
  Link,
  Typography,
  useMobileMediaQuery,
} from '@iheartjane/reefer';

import type { MenuProductCarouselProps } from './menuProductCarousel.types';

export const ListViewCarousel = ({
  children,
  name,
  onHover,
  onLeave,
  variant,
  viewAllTo,
  viewAllOnClick,
  ...props
}: MenuProductCarouselProps) => {
  const isMobile = useMobileMediaQuery({});
  const isAd = variant === 'sponsored' || variant === 'sponsored-inline';
  return (
    <Box
      ariaLabel={isAd ? 'Sponsored content' : name}
      border={
        variant === 'sponsored-inline' ? 'transparent-black-ten' : undefined
      }
      borderWidth={variant === 'sponsored-inline' ? '0 0 1px 0' : undefined}
      pb={variant === 'sponsored-inline' ? 24 : 0}
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
      {...props}
    >
      <Flex
        as="section"
        width="100%"
        gap={isMobile ? 16 : 24}
        flexDirection="column"
        alignItems="center"
      >
        <Flex
          pt={variant === 'sponsored-inline' ? 24 : 0}
          width="100%"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box>
            {variant?.includes('sponsored') && (
              <Typography color="text-light">Sponsored</Typography>
            )}
            <Typography
              as={variant?.includes('sponsored') ? 'p' : 'h2'}
              branded
              variant="header-bold"
            >
              {name}
            </Typography>
          </Box>
          {(viewAllTo || viewAllOnClick) && (
            <>
              {isMobile ? (
                <Link
                  ariaLabel={props.buttonAriaLabel || `View all ${name}`}
                  ml={12}
                  onClick={viewAllOnClick}
                  to={viewAllTo}
                >
                  <Typography>View all</Typography>
                </Link>
              ) : (
                <Button
                  aria-label={props.buttonAriaLabel || `View all ${name}`}
                  label="View all"
                  ml={12}
                  onClick={viewAllOnClick}
                  to={viewAllTo}
                  variant="tertiary"
                />
              )}
            </>
          )}
        </Flex>
        {children}
      </Flex>
    </Box>
  );
};
